import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Grid, Paper, Typography } from "@mui/material";

import dayjs from "dayjs";

import actions from "../../../../store/actions";
import ls from "../../../../Localization";
import { State } from "store/reducers";
import useStyles from "./styles";

import NFSe from "./NFSe";

import { useParams } from "react-router-dom";
import { CNPJ } from "Components/NumberFormat";
import { CompanyDetailState } from "store/reducers/company/detail";
import { useNavigate } from "react-router-dom";

export function CompanyDetail() {
	const navigate = useNavigate();
	const { id } = useParams();
	const classes = useStyles({});
	const dispatch = useDispatch<any>();

	useEffect(() => {
		if (!id) return;

		dispatch(actions.company.detail.clearValues());
		dispatch(actions.company.detail.getCompany(id));
	}, [dispatch, id]);

	const handleEdit = () => {
		navigate(`/Dashboard/Company/${id}/Edit`);
	};

	const { item } = useSelector<State, CompanyDetailState>(s => s.companyDetail);

	if (!item) return null;

	const { createdAt, socialName, businessName, cnpj, code }: any = item;

	return (
		<Grid container justifyContent="center" spacing={5}>
			<Grid item xs={11}>
				<Paper className={classes.root}>
					<div className={classes.header}>
						<Typography variant="h6">{ls.companyData}</Typography>
						<div>
							<Button color="primary" onClick={handleEdit}>
								{ls.edit}
							</Button>
						</div>
					</div>
					<hr className={classes.line} />

					<Grid container spacing={2} className={classes.form}>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.creationDate}</strong>:{" "}
							{dayjs(createdAt).format(ls.dateFormatWithoutSeconds)}
						</Grid>

						<Grid item xs={12} sm={6} md={6} lg={4}>
							<strong>{ls.businessName}</strong>: {businessName}
						</Grid>

						<Grid item xs={12} sm={6} md={6} lg={5}>
							<strong>{ls.socialName}</strong>: {socialName}
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.cnpj}</strong>:{" "}
							<CNPJ value={cnpj} displayType="text" />
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.code}</strong>: {code}
						</Grid>
					</Grid>
				</Paper>
			</Grid>
			<Grid item xs={11}>
				<NFSe id={id} />
			</Grid>
		</Grid>
	);
}

export default CompanyDetail;
